<div class="container" [class.popup-mode]="isPopup()">
  <div class="form-container">
    <div class="header-container">
      <div class="button-container">
        <button mat-raised-button color="accent" (click)="goBack()">
          <mat-icon>arrow_back</mat-icon>
        </button>
      </div>
      <h2>Precificação e Manutenção de Preço</h2>
    </div>

    <form [formGroup]="precoForm" class="preco-form">
      <div class="result-summary compact-summary">

        <div class="summary-item summary-item--produto" *ngIf="produtoSelected; else semProduto">
          <span class="summary-label">Produto</span>
          <strong class="summary-value produto-desc">
            {{ produtoSelected.codigo?.toString()?.padStart(6, '0') }} — {{ produtoSelected.descricao }}
          </strong>
        </div>
        <ng-template #semProduto>
          <div class="summary-item summary-item--produto">
            <span class="summary-label">Produto</span>
            <strong class="summary-value summary-empty">Nenhum produto selecionado</strong>
          </div>
        </ng-template>

        <div class="summary-item emphasis">
          <span class="summary-label">Preço atual</span>
          <strong class="summary-value">{{ precoVendaAtual | number:'1.2-2' }}</strong>
          <span *ngIf="precoVenda > 0 && precoVenda !== precoVendaAtual"
                class="summary-change"
                [class.change-up]="precoVenda > precoVendaAtual"
                [class.change-down]="precoVenda < precoVendaAtual">
            → {{ precoVenda | number:'1.2-2' }}
          </span>
        </div>

        <div class="summary-item">
          <span class="summary-label">Diferença</span>
          <strong class="summary-value"
                  [class.change-up]="(precoVenda - precoVendaAtual) > 0"
                  [class.change-down]="(precoVenda - precoVendaAtual) < 0">
            {{ (precoVenda - precoVendaAtual) | number:'1.2-2' }}
          </strong>
        </div>

        <div class="summary-item">
          <span class="summary-label">Índice</span>
          <strong class="summary-value">{{ indiceCalc | number:'1.2-2' }}</strong>
        </div>

        <div class="summary-item">
          <span class="summary-label">Valor do lucro</span>
          <strong class="summary-value">{{ valorPrecoVenda | number:'1.2-2' }}</strong>
        </div>

        <div class="summary-item summary-item--meta">
          <span class="summary-label">Estoque e custo</span>
          <div class="summary-meta-row">
            <span class="summary-meta-label">Saldo disponível</span>
            <strong class="summary-meta-value">{{ saldo | number:'1.2-2' }}</strong>
          </div>
          <div class="summary-meta-row">
            <span class="summary-meta-label">Custo de reposição</span>
            <strong class="summary-meta-value">{{ precoForm.controls['custoCompra'].value | number:'1.2-2' }}</strong>
          </div>
        </div>

      </div>

      <mat-tab-group class="preco-tabs" mat-stretch-tabs="false" animationDuration="0ms">
        <mat-tab label="Produto e Encargos">
          <div class="tab-content">
            <div class="panel-content">
              <div class="input-row">
                <mat-form-field appearance="outline" class="flex-field">
                  <mat-label>Produto</mat-label>
                  <mat-select [formControl]="precoForm.controls['produto']" (selectionChange)="onSelectionChangeProduto($event)" required>
                    <mat-option>
                      <ngx-mat-select-search
                        [formControl]="precoForm.controls['searchProduto']"
                        placeholderLabel="Pesquisar Produto..."
                        noEntriesFoundLabel="Produto não encontrado"
                        [searching]="searching">
                      </ngx-mat-select-search>
                    </mat-option>
                    <mat-option *ngFor="let produto of produtos" [value]="produto">
                      <span>{{ produto?.codigo?.toString().padStart(5, '0') }}-</span>
                      <span>{{ produto?.descricao?.trim() }}</span>
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="precoForm.controls['produto'].hasError('required')">
                    Produto é obrigatório.
                  </mat-error>
                </mat-form-field>
              </div>

              <div class="fields-grid fields-grid-3">
                <mat-form-field appearance="outline" class="grid-field">
                  <mat-label>Custo de Reposição</mat-label>
                  <input matInput type="text" [formControl]="precoForm.controls['custoCompra']" currencyMask
                    [options]="{ prefix: '', align: 'right', thousands: '.', allowNegative: false, decimal: ',', precision: 2 }">
                </mat-form-field>
                <div class="grid-field restore-action" *ngIf="custoManualEditado">
                  <button mat-stroked-button color="primary" type="button" class="restore-btn" (click)="restaurarCustoCadastro()">
                    <mat-icon>refresh</mat-icon>
                    Restaurar custo do sistema
                  </button>
                </div>
                <mat-form-field appearance="outline" class="grid-field">
                  <mat-label>Preço Venda Atual (Praticado)</mat-label>
                  <input matInput type="text" [value]="precoVendaAtual | number:'1.2-2'" readonly>
                </mat-form-field>
              </div>

              <div class="section-title">Encargos e Custos</div>
              <div class="fields-grid fields-grid-3">
                <mat-form-field appearance="outline" class="grid-field">
                  <mat-label>(%) Imposto S/Venda</mat-label>
                  <input matInput type="text" formControlName="impostoSVenda" currencyMask
                    [options]="{ prefix: '', align: 'right', thousands: '.', allowNegative: false, decimal: ',', precision: 2 }">
                  <span matSuffix>%</span>
                </mat-form-field>
                <mat-form-field appearance="outline" class="grid-field">
                  <mat-label>(%) Acréscimo Financeiro</mat-label>
                  <input matInput type="text" formControlName="acrescimoFinanceiro" currencyMask
                    [options]="{ prefix: '', align: 'right', thousands: '.', allowNegative: false, decimal: ',', precision: 2 }">
                  <span matSuffix>%</span>
                </mat-form-field>
                <mat-form-field appearance="outline" class="grid-field">
                  <mat-label>(%) Despesa Operacional</mat-label>
                  <input matInput type="text" formControlName="despesaOperacional" currencyMask
                    [options]="{ prefix: '', align: 'right', thousands: '.', allowNegative: false, decimal: ',', precision: 2 }">
                  <span matSuffix>%</span>
                </mat-form-field>
                <mat-form-field appearance="outline" class="grid-field">
                  <mat-label>(%) Outros</mat-label>
                  <input matInput type="text" formControlName="outros" currencyMask
                    [options]="{ prefix: '', align: 'right', thousands: '.', allowNegative: false, decimal: ',', precision: 2 }">
                  <span matSuffix>%</span>
                </mat-form-field>
                <mat-form-field appearance="outline" class="grid-field">
                  <mat-label>(%) Comissão</mat-label>
                  <input matInput type="text" formControlName="comissao" currencyMask
                    [options]="{ prefix: '', align: 'right', thousands: '.', allowNegative: false, decimal: ',', precision: 2 }">
                  <span matSuffix>%</span>
                </mat-form-field>
                <mat-form-field appearance="outline" class="grid-field">
                  <mat-label>(%) Total Encargos</mat-label>
                  <input matInput type="text" [value]="totalEncargos | number:'1.2-2'" readonly>
                  <span matSuffix>%</span>
                </mat-form-field>
              </div>
            </div>
          </div>
        </mat-tab>

        <mat-tab label="Parâmetros de Precificação">
          <div class="tab-content">
            <div class="panel-content">
              <p class="panel-tip">Dica: ao informar um parâmetro, os demais são zerados automaticamente.</p>
              <div class="fields-grid fields-grid-3">
                <mat-form-field appearance="outline" class="grid-field">
                  <mat-label>(%) Entrar c/ Margem de Lucro S/ Preço de Venda</mat-label>
                  <input matInput type="text" formControlName="lucrosSPreInput" currencyMask
                    [options]="{ prefix: '', align: 'right', thousands: '.', allowNegative: false, decimal: ',', precision: 2 }">
                  <span matSuffix>%</span>
                </mat-form-field>
                <mat-form-field appearance="outline" class="grid-field">
                  <mat-label>Entrar c/ Valor do Lucro Desejado S/ Preço de Venda</mat-label>
                  <input matInput type="text" formControlName="valorPrecoVendaInput" currencyMask
                    [options]="{ prefix: '', align: 'right', thousands: '.', allowNegative: false, decimal: ',', precision: 2 }">
                </mat-form-field>
                <mat-form-field appearance="outline" class="grid-field">
                  <mat-label>(%) Entrar c/ Margem de Lucro S/ o Custo</mat-label>
                  <input matInput type="text" formControlName="lucrosSPrecoCustoInput" currencyMask
                    [options]="{ prefix: '', align: 'right', thousands: '.', allowNegative: false, decimal: ',', precision: 2 }">
                  <span matSuffix>%</span>
                </mat-form-field>
                <mat-form-field appearance="outline" class="grid-field">
                  <mat-label>Entrar c/ Valor do Lucro Desejado S/ o Custo</mat-label>
                  <input matInput type="text" formControlName="valorPrecoCustoInput" currencyMask
                    [options]="{ prefix: '', align: 'right', thousands: '.', allowNegative: false, decimal: ',', precision: 2 }">
                </mat-form-field>
                <mat-form-field appearance="outline" class="grid-field">
                  <mat-label>Preço de Venda Desejado</mat-label>
                  <input matInput type="text" formControlName="precoVendaInput" currencyMask
                    [options]="{ prefix: '', align: 'right', thousands: '.', allowNegative: false, decimal: ',', precision: 2 }">
                </mat-form-field>
                <mat-form-field appearance="outline" class="grid-field">
                  <mat-label>Índice Desejado</mat-label>
                  <input matInput type="text" formControlName="indiceInput" currencyMask
                    [options]="{ prefix: '', align: 'right', thousands: '.', allowNegative: false, decimal: ',', precision: 3 }">
                </mat-form-field>
              </div>
            </div>
          </div>
        </mat-tab>

        <mat-tab label="Resultado da Precificação">
          <div class="tab-content">
            <div class="panel-content">
              <div class="section-title">Total Encargos/Custos sobre a Venda</div>
              <div class="fields-grid fields-grid-3">
                <mat-form-field appearance="outline" class="grid-field">
                  <mat-label>Valor Total Encargo</mat-label>
                  <input matInput type="text" [value]="valorEncargo | number:'1.2-2'" readonly>
                </mat-form-field>
                <mat-form-field appearance="outline" class="grid-field">
                  <mat-label>(%) Encargos/Custo equivalente Preço Venda</mat-label>
                  <input matInput type="text" [value]="totalCustoVenda | number:'1.2-2'" readonly>
                  <span matSuffix>%</span>
                </mat-form-field>
                <mat-form-field appearance="outline" class="grid-field">
                  <mat-label>Custo Total com Encargos</mat-label>
                  <input matInput type="text" [value]="valorCustoVenda | number:'1.2-2'" readonly>
                </mat-form-field>
              </div>

              <div class="section-title">Resultado da Precificação</div>
              <div class="fields-grid fields-grid-3">
                <mat-form-field appearance="outline" class="grid-field">
                  <mat-label>(%) Lucro S/Preço Venda</mat-label>
                  <input matInput type="text" [value]="lucrosSPrecoVenda | number:'1.2-2'" readonly>
                  <span matSuffix>%</span>
                </mat-form-field>
                <mat-form-field appearance="outline" class="grid-field">
                  <mat-label>Valor Lucro Líquido S/ Preço Venda</mat-label>
                  <input matInput type="text" [value]="valorPrecoVenda | number:'1.2-2'" readonly>
                </mat-form-field>
                <mat-form-field appearance="outline" class="grid-field">
                  <mat-label>(%) Lucro S/Preço Custo</mat-label>
                  <input matInput type="text" [value]="lucrosSPrecoCusto | number:'1.2-2'" readonly>
                  <span matSuffix>%</span>
                </mat-form-field>
                <mat-form-field appearance="outline" class="grid-field">
                  <mat-label>Valor Lucro S/ Preço Custo</mat-label>
                  <input matInput type="text" [value]="valorPrecoCusto | number:'1.2-2'" readonly>
                </mat-form-field>
                <mat-form-field appearance="outline" class="grid-field">
                  <mat-label>Preço Venda Sugerido</mat-label>
                  <input matInput type="text" [value]="precoVenda | number:'1.2-2'" readonly>
                </mat-form-field>
                <mat-form-field appearance="outline" class="grid-field">
                  <mat-label>Índice Calculado</mat-label>
                  <input matInput type="text" [value]="indiceCalc | number:'1.2-2'" readonly>
                </mat-form-field>
              </div>

              <div class="action-wrapper">
                <button mat-raised-button color="primary" (click)="gravarPrecoVendaSugerido()">
                  Gravar Preço Venda Sugerido
                </button>
              </div>

              <mat-expansion-panel class="info-panel">
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    <mat-icon>info</mat-icon>
                    Informações para Atualização de Custo
                  </mat-panel-title>
                  <mat-panel-description>
                    Orientações Operacionais
                  </mat-panel-description>
                </mat-expansion-panel-header>

                <mat-card class="info-highlight-card">
                  <mat-card-content class="info-panel-content">
                    <p>
                      <mat-icon aria-hidden="false">place</mat-icon>
                      Para gravar <strong>custo e estoque</strong>, realize um Lançamento de
                      <strong>Contagem de Estoque</strong> ou uma <strong>Reavaliação de Custo</strong>.
                    </p>

                    <p>
                      <mat-icon aria-hidden="false">sync_alt</mat-icon>
                      Esse processo gera uma Movimentação específica para atualização de estoque e custos no <strong>InfoKaw</strong>.
                    </p>

                    <p>
                      <mat-icon>support_agent</mat-icon>
                      Caso precise, entre em contato com o suporte InfoKaw para mais informações.
                    </p>
                  </mat-card-content>
                </mat-card>
              </mat-expansion-panel>
            </div>
          </div>
        </mat-tab>
      </mat-tab-group>
    </form>
  </div>
</div>
